export default __webpack_public_path__ + "static/media/Search_Icon.28e9b42d.svg";